var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.filter_desc.length > 0)?_c('div',{staticClass:"alert alert-warning",attrs:{"id":"filter-list"}},[_c('strong',[_vm._v(_vm._s(_vm.t_active_filter))]),_vm._v(" "+_vm._s(_vm.filter_desc)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }